import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import app from './modules/app'
import goods from './modules/goods'
import order from './modules/order'
import wechat from './modules/wechat'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    goods,
    order,
    wechat
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js